module.exports = __webpack_public_path__ + "img/20210814.644534a9.gif";